import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_posts_toolbar = _resolveComponent("posts-toolbar")!
  const _component_posts_order = _resolveComponent("posts-order")!
  const _component_pagination_mode = _resolveComponent("pagination-mode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_posts_toolbar, {
        filters: _ctx.filters,
        "maximize-btn": {flat: true},
        minimized: "",
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event)))
      }, null, 8, ["filters"])
    ]),
    _createVNode(_component_posts_order, {
      order: _ctx.filters.order,
      class: "q-my-sm",
      flat: "",
      onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:filters', { ..._ctx.filters, order: $event })))
    }, null, 8, ["order"]),
    _createVNode(_component_pagination_mode, {
      "model-value": _ctx.paginationMode,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:paginationMode', $event))),
      flat: ""
    }, null, 8, ["model-value"])
  ]))
}